import { type AxiosResponse } from 'axios'
import { baseApi } from 'entities/Auth'
import { type IResponseCnam } from 'entities/Compliance/api/types/cnamType'
import {
  type IResponseVoiceIntegrity,
  type IParamsSubmitVoiceIntegrity,
  type IResponseTenDlcVoiceIntegrity,
  type IResponseVoiceIntegrityUseCase,
  type IParamsAddShakenStir,
  type IResponseOrganizationShakenStir,
  type IParamsAddCnamCallerId,
  type IParamsUpdateCnamCallerId,
  type IParamsAddNumbersToCnamCallerId,
  type IParamsDeleteNumbersFromCnamCallerId,
} from 'entities/Compliance/api/types/voiceServicesTypes'
import { type IResponseNumber } from 'entities/Phone/api/types'

class VoiceServicesApiClass {
  getComplianceVoiceServicesList(): Promise<AxiosResponse<IResponseTenDlcVoiceIntegrity>> {
    return baseApi.get('compliance/voice-compliance/services/list')
  }

  getVoiceIntegrityUseCases(): Promise<AxiosResponse<IResponseVoiceIntegrityUseCase[]>> {
    return baseApi.get('compliance/enum/voice-integrity-use-cases')
  }

  submitVoiceIntegrity(
    params: IParamsSubmitVoiceIntegrity
  ): Promise<AxiosResponse<IResponseVoiceIntegrity>> {
    return baseApi.post('compliance/voice-integrity', params)
  }

  updateVoiceIntegrity(
    params: IParamsSubmitVoiceIntegrity,
    id: number
  ): Promise<AxiosResponse<IResponseVoiceIntegrity>> {
    return baseApi.put(`compliance/voice-integrity/${id}/update`, params)
  }

  addOrganizationShakenStir(
    params: IParamsAddShakenStir
  ): Promise<AxiosResponse<IResponseOrganizationShakenStir>> {
    return baseApi.post('compliance/shaken-stir', params)
  }

  addCnamCallerId(params: IParamsAddCnamCallerId): Promise<AxiosResponse<IResponseCnam>> {
    return baseApi.post('compliance/cnam', params)
  }

  updateCnamCallerId(
    params: IParamsUpdateCnamCallerId,
    id: number
  ): Promise<AxiosResponse<IResponseCnam>> {
    return baseApi.put(`compliance/cnam/${id}`, params)
  }

  addNumbersToCnamCallerId(
    params: IParamsAddNumbersToCnamCallerId
  ): Promise<AxiosResponse<IResponseNumber[]>> {
    return baseApi.post('organization/cnam/phone-numbers', params)
  }

  deleteNumbersFromCnamCallerId(
    params: IParamsDeleteNumbersFromCnamCallerId
  ): Promise<AxiosResponse<IResponseNumber[]>> {
    return baseApi.delete('organization/cnam/phone-numbers', { params })
  }

  deleteCnamCallerId(id: number): Promise<AxiosResponse<IResponseTenDlcVoiceIntegrity>> {
    return baseApi.delete(`compliance/cnam/${id}`)
  }

  getCnamNumbers(id: number): Promise<AxiosResponse<IResponseNumber[]>> {
    return baseApi.get(`organization/cnam/${id}/phone-numbers`)
  }
}

export const VoiceServicesApi = new VoiceServicesApiClass()
